import { MessageCircle } from 'lucide-react';
import { BRAND } from '@/lib/data';

export const FloatingWhatsApp = () => (
    <a
        href={BRAND.whatsapp}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 group flex items-center gap-2 bg-gold text-ink px-4 py-3 shadow-lg shadow-black/40 hover:bg-bone transition-colors duration-300"
    >
        <MessageCircle size={18} />
        <span className="hidden sm:inline text-xs uppercase tracking-[0.2em] font-medium">
            Chat
        </span>
    </a>
);
